<template>
  <div>
    <PageHeader :title="title" :items="items"/>
    <div class="row">
      <div class="col-lg-12" v-if="order.order_buyer">
        <div class="card">
          <div class="card-body">
            <div class="invoice-title">
              <h4 class="float-end font-size-16">{{$t('pages.order.show.order')}} # {{ order.amazon_order_id }}</h4>
              <div>
                <i class="mdi mdi-information-outline font-size-18"/>
              </div>
            </div>
            <hr/>
            <div class="row">
              <div class="col-6">
                <address>
                  <strong>{{ $t('pages.order.show.buyer') }}:</strong>
                  <br/> {{ order.order_buyer.buyer_name }} <br/>
                  {{ order.order_buyer.buyer_email }}
                </address>
              </div>
              <div class="col-6 text-sm-end">
                <address>
                  <strong>{{ $t('pages.order.show.shipped') }}:</strong>
                  <br/>{{ address(order.address) }}
                </address>
              </div>
            </div>
            <div class="row">
              <div class="col-6 mt-3">
                <address>
                  <strong>{{ $t('pages.order.show.fulfillment') }}:</strong>
                  <br/>{{ order.fulfillment_channel }}
                </address>
              </div>
              <div class="col-6 mt-3 text-sm-end">
                <address>
                  <strong>{{ $t('pages.order.show.order_date') }}:</strong>
                  <br/>{{ order.purchase_date }}
                  <br/>
                  <br/>
                </address>
              </div>
            </div>
            <div class="p-2 mt-3">
              <h3 class="font-size-16">{{ $t('pages.order.show.order_summary') }}</h3>
            </div>
            <div class="table-responsive">
              <table class="table">
                <thead>
                <tr>
                  <th style="width: 70px">{{ $t('pages.order.show.no') }}.</th>
                  <th>{{ $t('pages.order.show.item') }}</th>
                  <th>{{ $t('pages.order.show.shipped') }} </th>
                  <th>{{ $t('pages.order.show.ordered') }}</th>
                  <th class="text-sm-end">{{ $t('pages.order.show.price') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in orderItems" :key="item.id">
                  <td>
                    <div class="media mb-4">
                      <div class="me-3">
                        <img
                            class="media-object rounded-circle avatar-xs"
                            alt
                            :src="item.catalog.image_url"
                        />
                      </div>
                    </div>
                  </td>
                  <td>{{ item.catalog.item_name }}</td>
                  <td>{{ item.quantity_ordered }}</td>
                  <td>{{ item.quantity_shipped }}</td>
                  <td class="text-sm-end">{{ item.catalog.price }}</td>
                </tr>
                <tr>
                  <td colspan="4" class="border-0 text-sm-end">
                    <strong>{{$t('pages.order.show.total')}}</strong>
                  </td>
                  <td class="border-0 text-sm-end">
                    <h4 class="m-0">{{ order.money.currency_code }} {{ order.money.amount }}</h4>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="d-print-none">
              <div class="float-end">
                <a
                    href="javascript:window.print()"
                    class="btn btn-success waves-effect waves-light me-1"
                ><i class="fa fa-print"></i
                ></a>
                <a
                    @click="returnBack"
                    class="btn btn-primary w-md waves-effect waves-light"
                >{{ $t('pages.order.show.back_button') }}</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import queryBuilder from "../../../mixins/queryBuilder";
import OrderService from "../../../Services/Api/OrderService";

export default {
  name: "OrderShow",
  mixins: [queryBuilder],
  page() {
    return {
      title: this.$t('pages.order.show.title'),
      meta: [
        {
          name: "description",
          content: this.$t('common.app_title')
        }
      ]
    }
  },
  data() {
    return {
      items: [
        {
          text: this.$t('pages.order.show.items.first'),
          href: "/orders",
        },
        {
          text: this.$t('pages.order.show.items.second'),
          active: true,
        },
      ],
      title: this.$t('pages.order.show.title'),
      orderItems: [],
      order: {}
    }
  },
  methods: {
    async getOrder() {
      const orderId = this.$route.params.orderId
      const {data: order} = await OrderService.show({id: orderId})
      this.order = order.data
      this.orderItems = order.data.order_item
    },
    address(address) {
      let adr = ''
      for (const item in address) {
        if (address[item]) {
          adr += ' ' + address[item]
        }
      }
      return adr
    },
    returnBack() {
      this.$router.push({name: 'order.list'})
    }
  },
  created() {
    this.getOrder()
  }
};
</script>